if (!customElements.get("product-modal")) {
  customElements.define(
    "product-modal",
    class ProductModal extends ModalDialog {
      constructor() {
        super();

        this.previousButton = null;
        this.nextButton = null;

        /*
         * Stores the media ID of the image currently
         * being viewed inside the popup.
         */
        this.lastViewedMediaId = null;

        this.handlePrevious = this.handlePrevious.bind(this);
        this.handleNext = this.handleNext.bind(this);
        this.handleKeydown = this.handleKeydown.bind(this);
      }

      /* =====================================================
         CONNECTED
         ===================================================== */

      connectedCallback() {
        super.connectedCallback();

        this.previousButton = this.querySelector(
          ".product-media-modal__nav--prev"
        );

        this.nextButton = this.querySelector(
          ".product-media-modal__nav--next"
        );

        if (this.previousButton) {
          this.previousButton.addEventListener(
            "click",
            this.handlePrevious
          );
        }

        if (this.nextButton) {
          this.nextButton.addEventListener(
            "click",
            this.handleNext
          );
        }
      }

      /* =====================================================
         DISCONNECTED
         ===================================================== */

      disconnectedCallback() {
        if (this.previousButton) {
          this.previousButton.removeEventListener(
            "click",
            this.handlePrevious
          );
        }

        if (this.nextButton) {
          this.nextButton.removeEventListener(
            "click",
            this.handleNext
          );
        }

        document.removeEventListener(
          "keydown",
          this.handleKeydown
        );
      }

      /* =====================================================
         HIDE / CLOSE MODAL
         ===================================================== */

      hide() {
        /*
         * IMPORTANT:
         *
         * Before closing the popup, save the image that
         * is currently being viewed and make that image
         * active in the product gallery.
         */
        this.saveCurrentMediaToProductPage();

        if (screen && screen.width > 989) {
          const closeBtnPop = document.querySelector(
            ".product-media-modal__toggle"
          );

          if (closeBtnPop) {
            closeBtnPop.addEventListener(
              "click",
              () => {
                const imagePosFix =
                  document.querySelectorAll(
                    ".global-media-settings"
                  );

                imagePosFix.forEach((el) => {
                  el.style.transformOrigin = "0 0";
                  el.classList.remove("zoomed");
                });

                const modal =
                  document.querySelector("product-modal");

                if (modal) {
                  modal.removeAttribute("open");
                }

                document.body.classList.remove(
                  "overflow-hidden"
                );

                document.body.dispatchEvent(
                  new CustomEvent("modalClosed")
                );
              },
              { once: true }
            );
          }
        } else {
          super.hide();
        }

        document.removeEventListener(
          "keydown",
          this.handleKeydown
        );
      }

      /* =====================================================
         SHOW MODAL
         ===================================================== */

      show(opener) {
        super.show(opener);

        /*
         * Store the image that originally opened
         * the popup.
         */
        this.lastViewedMediaId =
          opener?.getAttribute("data-media-id") || null;

        this.showActiveMedia();

        document.addEventListener(
          "keydown",
          this.handleKeydown
        );
      }

      /* =====================================================
         SHOW ACTIVE MEDIA
         ===================================================== */
showActiveMedia() {

  /*
   * Navigation buttons
   */
  const navButtons = this.querySelectorAll(
    ".product-media-modal__nav"
  );


  /*
   * IMPORTANT:
   *
   * Only hide buttons if this is the FIRST image
   * being loaded when the popup opens.
   *
   * Do NOT hide them when Next / Previous is clicked.
   */
  if (!this.lastViewedMediaId) {
    navButtons.forEach((button) => {
      button.classList.remove("media-ready");
    });
  }


  /*
   * Get the media ID of the image that opened
   * the popup.
   */
  const mediaId =
    this.openedBy?.getAttribute("data-media-id");

  if (!mediaId) {
    return;
  }


  /*
   * Remove active state from other media.
   */
  this.querySelectorAll(
    `[data-media-id]:not([data-media-id="${mediaId}"])`
  ).forEach((element) => {
    element.classList.remove("active");
  });


  /*
   * Find active media.
   */
  const activeMedia = this.querySelector(
    `[data-media-id="${mediaId}"]`
  );

  if (!activeMedia) {
    return;
  }


  /*
   * Remember current media.
   */
  this.lastViewedMediaId = mediaId;


  /*
   * Get template.
   */
  const activeMediaTemplate =
    activeMedia.querySelector("template");

  const activeMediaContent =
    activeMediaTemplate
      ? activeMediaTemplate.content
      : null;


  /*
   * Activate media.
   */
  activeMedia.classList.add("active");


  /*
   * Show navigation when image has loaded.
   */
  const showNavigation = () => {

    navButtons.forEach((button) => {
      button.classList.add("media-ready");
    });

  };


  /*
   * Find image.
   */
  const image =
    activeMedia.querySelector("img");


  if (image) {

    /*
     * Image already loaded.
     */
    if (
      image.complete &&
      image.naturalWidth > 0
    ) {

      showNavigation();

    } else {

      /*
       * IMPORTANT:
       *
       * We DO NOT remove media-ready here.
       *
       * Therefore, if the user is already viewing
       * an image and clicks Next, the buttons remain
       * visible and fixed while the new image loads.
       */
      image.addEventListener(
        "load",
        showNavigation,
        { once: true }
      );

      image.addEventListener(
        "error",
        showNavigation,
        { once: true }
      );
    }

  } else {

    /*
     * Non-image media.
     */
    showNavigation();

  }


  /*
   * Position active media.
   */
  activeMedia.scrollIntoView();


  /*
   * Center media inside modal.
   */
  const container =
    this.querySelector('[role="document"]');


  if (container) {

    container.scrollLeft =
      (activeMedia.width -
        container.clientWidth) / 2;

  }


  /*
   * Deferred media / YouTube.
   */
  if (
    activeMedia.nodeName === "DEFERRED-MEDIA" &&
    activeMediaContent &&
    activeMediaContent.querySelector(".js-youtube")
  ) {

    activeMedia.loadContent();

  }


  /*
   * Update navigation.
   */
  this.updateNavigation();
}

      /* =====================================================
         GET MEDIA ITEMS
         ===================================================== */

      getMediaItems() {
        return Array.from(
          this.querySelectorAll(
            "[data-media-id]"
          )
        );
      }

      /* =====================================================
         GET ACTIVE INDEX
         ===================================================== */

      getActiveIndex() {
        const mediaItems =
          this.getMediaItems();

        return mediaItems.findIndex((media) =>
          media.classList.contains("active")
        );
      }

      /* =====================================================
         PREVIOUS
         ===================================================== */

      handlePrevious() {
        const mediaItems =
          this.getMediaItems();

        if (mediaItems.length <= 1) {
          return;
        }

        let currentIndex =
          this.getActiveIndex();

        if (currentIndex === -1) {
          currentIndex = 0;
        }

        const previousIndex =
          currentIndex === 0
            ? mediaItems.length - 1
            : currentIndex - 1;

        this.activateMedia(
          mediaItems[previousIndex]
        );
      }

      /* =====================================================
         NEXT
         ===================================================== */

      handleNext() {
        const mediaItems =
          this.getMediaItems();

        if (mediaItems.length <= 1) {
          return;
        }

        let currentIndex =
          this.getActiveIndex();

        if (currentIndex === -1) {
          currentIndex = 0;
        }

        const nextIndex =
          currentIndex === mediaItems.length - 1
            ? 0
            : currentIndex + 1;

        this.activateMedia(
          mediaItems[nextIndex]
        );
      }

      /* =====================================================
         ACTIVATE MEDIA
         ===================================================== */

  activateMedia(media) {
  if (!media) {
    return;
  }

  /*
   * Get media ID.
   */
  const mediaId =
    media.getAttribute("data-media-id");

  if (!mediaId) {
    return;
  }


  /*
   * Remember the current image.
   */
  this.lastViewedMediaId = mediaId;


  /*
   * Get all media.
   */
  const mediaItems =
    this.getMediaItems();


  /*
   * Remove active state.
   */
  mediaItems.forEach((item) => {
    item.classList.remove("active");
  });


  /*
   * Activate selected media.
   */
  media.classList.add("active");


  /*
   * Center image inside modal.
   */
  const container =
    this.querySelector('[role="document"]');


  if (container) {
    container.scrollTo({
      left:
        media.offsetLeft -
        (container.clientWidth -
          media.offsetWidth) / 2,

      behavior: "smooth",
    });
  }


  /*
   * IMPORTANT:
   *
   * We intentionally DO NOT hide the navigation
   * buttons here.
   *
   * Once they have appeared after the first image
   * loads, they stay visible and fixed while the
   * next image loads.
   */


  /*
   * Find image.
   */
  const image =
    media.querySelector("img");


  /*
   * Navigation buttons.
   */
  const navButtons =
    this.querySelectorAll(
      ".product-media-modal__nav"
    );


  /*
   * When the new image is ready, make sure
   * navigation is visible.
   */
  const showNavigation = () => {

    navButtons.forEach((button) => {
      button.classList.add("media-ready");
    });

  };


  if (image) {

    if (
      image.complete &&
      image.naturalWidth > 0
    ) {

      showNavigation();

    } else {

      /*
       * DO NOT remove media-ready.
       *
       * Buttons remain visible in exactly the
       * same fixed position while image loads.
       */
      image.addEventListener(
        "load",
        showNavigation,
        { once: true }
      );

      image.addEventListener(
        "error",
        showNavigation,
        { once: true }
      );
    }

  } else {

    showNavigation();

  }


  /*
   * Deferred media / YouTube.
   */
  const mediaTemplate =
    media.querySelector("template");

  const mediaContent =
    mediaTemplate
      ? mediaTemplate.content
      : null;


  if (
    media.nodeName === "DEFERRED-MEDIA" &&
    mediaContent &&
    mediaContent.querySelector(".js-youtube")
  ) {

    media.loadContent();

  }


  /*
   * Update navigation.
   */
  this.updateNavigation();
}

      /* =====================================================
         SAVE CURRENT POPUP IMAGE
         ===================================================== */

      saveCurrentMediaToProductPage() {
        /*
         * Find whatever image is currently active
         * inside the popup.
         */
        const activeMedia =
          this.querySelector(
            '[data-media-id].active'
          );

        if (!activeMedia) {
          return;
        }

        /*
         * Get its media ID.
         */
        const mediaId =
          activeMedia.getAttribute(
            "data-media-id"
          );

        if (!mediaId) {
          return;
        }

        /*
         * Remember it.
         */
        this.lastViewedMediaId = mediaId;

        /*
         * Tell the product gallery to display
         * this exact image.
         */
        this.updateProductPageMedia(mediaId);
      }

      /* =====================================================
         UPDATE PRODUCT PAGE MEDIA
         ===================================================== */

      updateProductPageMedia(mediaId) {
        if (!mediaId) {
          return;
        }

        /*
         * Find all elements with this media ID.
         */
        const allElements =
          document.querySelectorAll(
            `[data-media-id="${mediaId}"]`
          );

        let productThumbnail = null;

        /*
         * Look for the corresponding product-page
         * thumbnail, making sure we don't select
         * anything inside the popup.
         */
        allElements.forEach((element) => {
          if (
            !element.closest("product-modal")
          ) {
            /*
             * Prefer Dawn thumbnail elements.
             */
            if (
              element.matches(
                "button.thumbnail, .thumbnail, [data-target]"
              )
            ) {
              productThumbnail = element;
            }
          }
        });

        /*
         * Additional Dawn thumbnail lookup.
         */
        if (!productThumbnail) {
          productThumbnail =
            document.querySelector(
              `.thumbnail[data-media-id="${mediaId}"]`
            );
        }

        /*
         * Final fallback:
         * find the first matching element outside
         * the modal.
         */
        if (!productThumbnail) {
          allElements.forEach((element) => {
            if (
              !element.closest("product-modal") &&
              !productThumbnail
            ) {
              productThumbnail = element;
            }
          });
        }

        /*
         * Nothing found.
         */
        if (!productThumbnail) {
          return;
        }

        /*
         * IMPORTANT:
         *
         * Click the actual product-page thumbnail.
         *
         * Dawn's own gallery JavaScript will then
         * correctly update the:
         *
         * - main image
         * - active thumbnail
         * - slider position
         * - accessibility state
         */
        productThumbnail.click();
      }

      /* =====================================================
         UPDATE NAVIGATION
         ===================================================== */

      updateNavigation() {
        const mediaItems =
          this.getMediaItems();

        if (this.previousButton) {
          this.previousButton.style.display =
            mediaItems.length > 1
              ? ""
              : "none";
        }

        if (this.nextButton) {
          this.nextButton.style.display =
            mediaItems.length > 1
              ? ""
              : "none";
        }
      }

      /* =====================================================
         KEYBOARD NAVIGATION
         ===================================================== */

      handleKeydown(event) {
        if (!this.hasAttribute("open")) {
          return;
        }

        if (event.key === "ArrowLeft") {
          event.preventDefault();

          this.handlePrevious();
        }

        if (event.key === "ArrowRight") {
          event.preventDefault();

          this.handleNext();
        }
      }
    }
  );
}